// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"couponTable_tableWrapper__21fUL","noCouponMsg":"couponTable_noCouponMsg__FUqxB","selected":"couponTable_selected__1Am83"};